import type React from 'react';
import { G, Line } from 'react-native-svg';

import { usePlotDataContext } from './PlotDataProvider';
import type { ExternalComponentProps } from './types';

interface XGridProps {
  ticks?: number | number[];
  stroke?: string;
  opacity?: number;
  strokeDasharray?: number | number[];
  strokeWidth?: number;
}

type ExternalProps = ExternalComponentProps & XGridProps;

export const YGrid: React.FC<ExternalProps> = (props) => {
  const {
    ticks = 10,
    yScale,
    baseWidth,
    margin,
    stroke = 'lightgrey',
    opacity = 0.5,
    strokeDasharray,
    strokeWidth,
  } = usePlotDataContext(props);

  const tickMarks = typeof ticks === 'number' ? yScale.ticks(ticks) : ticks;

  return (
    <G>
      {tickMarks.map((t) => (
        <G key={t.toString()}>
          <Line
            stroke={stroke}
            y1={yScale(t)}
            x1={margin.left}
            y2={yScale(t)}
            x2={baseWidth - margin.right}
            opacity={opacity}
            strokeDasharray={strokeDasharray}
            strokeWidth={strokeWidth}
          />
        </G>
      ))}
    </G>
  );
};
